import type { ApiClient } from "../api/client";
import type { Me, Session } from "../api/types";
import { createStore } from "./store";

/**
 * ログイン状態と権限（/me）。所属・ロール・VC は変わるので、再生の通知が来たときなどに取り直す。
 * 画面に出す「操作できるか」は、この値（API の判定）に従う。最終判定はサーバー。
 */
export class SessionStore {
  readonly store = createStore<Session>({ status: "loading" });
  private loading: Promise<void> | null = null;

  constructor(private api: ApiClient) {}

  private epoch = 0;

  load(): Promise<void> {
    if (this.loading) return this.loading;
    const epoch = this.epoch;
    this.loading = this.api
      .getSession()
      .then((s) => {
        // 取り消しの前に出した問い合わせの答えは使わない
        if (epoch !== this.epoch) return;
        const prev = this.store.get();
        // 取り直しに失敗しても、ログイン済みの表示はすぐには消さない（保護データの新しい取得は API 側が止める）
        if (s.status === "unavailable" && prev.status === "signed_in" && s.code === "network") return;
        this.store.set(s);
      })
      .finally(() => {
        if (epoch === this.epoch) this.loading = null;
      });
    return this.loading;
  }

  /**
   * access_revoked を受けたとき（contracts/README.md）。保護表示をすぐ閉じてから /me を取り直す。
   * 取り直しが通信の失敗でも、ログイン済みの表示には戻さない
   */
  revoke(): Promise<void> {
    this.epoch += 1;
    this.loading = null;
    this.store.set({ status: "loading" });
    return this.load();
  }

  me(): Me | null {
    const s = this.store.get();
    return s.status === "signed_in" ? s.me : null;
  }

  setSignedOut() {
    this.store.set({ status: "signed_out" });
  }
}
